import type {} from "@lit/react";
import { Board as BoardElement, } from "@vaadin/board/vaadin-board.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { BoardElement, };
export type BoardEventMap = Readonly<{}>;
const events = {} as BoardEventMap;
export type BoardProps = WebComponentProps<BoardElement, BoardEventMap>;
export const Board = createComponent({
    elementClass: BoardElement, events, react: React, tagName: "vaadin-board"
});
